import { IonLabel, IonRow } from '@ionic/react';
import { Trans } from '@lingui/macro';
import { useAtom } from 'jotai';
import React, { useMemo } from 'react';

import { jobDetailsWithHousePropertiesPhotosAndStateAtom } from '../../store/Atoms';
import { APP_NAME } from '../../utils/constants';

type AcceptanceReportProps = {
    className?: string;
};

const AcceptanceReport: React.FunctionComponent<AcceptanceReportProps> = ({
    className,
}): JSX.Element => {
    const [value] = useAtom(jobDetailsWithHousePropertiesPhotosAndStateAtom);
    const job = useMemo(
        () => (value.state === 'hasData' ? value.data : undefined),
        [value]
    );
    const customerName = job?.jobDetails.customerId[1] || '-';
    const company = job?.jobDetails.partnerId[1] || '-';
    const currentDate = new Date().toISOString().split('T')[0];
    const newDevices = useMemo(
        () => (job ? job.devices.filter((device) => device.isNew).length : 0),
        [job]
    );

    const getInstallationSummary = (typeInstallation: string | undefined) => {
        if (typeInstallation === '1') {
            return (
                <Trans>
                    Installation <br />
                    Supplying and installing: <br />
                    <ul>
                        <li>
                            {newDevices}{' '}
                            <Trans>
                                Heaters to install <br />
                            </Trans>
                        </li>
                    </ul>
                </Trans>
            );
        } else if (typeInstallation === '2') {
            return (
                <Trans>
                    Repair <br />
                </Trans>
            );
        } else if (typeInstallation === '3') {
            return (
                <Trans>
                    Uninstallation <br />
                </Trans>
            );
        } else {
            return <Trans>Unknown installation type.</Trans>;
        }
    };

    const getTypeIntervention = (typeInstallation: string | undefined) => {
        if (typeInstallation === '1') {
            return <Trans>installation</Trans>;
        } else if (typeInstallation === '2') {
            return <Trans>repair</Trans>;
        } else if (typeInstallation === '3') {
            return <Trans>uninstallation</Trans>;
        } else {
            return <Trans>unknow</Trans>;
        }
    };

    return (
        <IonRow className="ion-justify-content-between ion-align-items-center ion-margin-top">
            <IonLabel>
                <Trans>
                    I, {customerName} as the client of the installation of the
                    following nature: <br />
                </Trans>
                {getInstallationSummary(job?.jobDetails.typeInstallation)}
                {currentDate}
                <br />
                <Trans>
                    Accept the{' '}
                    {getTypeIntervention(job?.jobDetails.typeInstallation)} in
                    the presence of {APP_NAME} represented by the company{' '}
                    {company}.
                </Trans>
            </IonLabel>
        </IonRow>
    );
};

export default AcceptanceReport;
